import { PrismicText, PrismicLink } from "@prismicio/react";

export const ProjectButton = ({ projectLink }) => {
    return (
      <a className="bn39" href={projectLink.project_link.url} target="_blank">
        <span className="bn39span"><PrismicText field={projectLink.project_link_label} /></span>
      </a>
    );
  };